export default "__VITE_ASSET__03bae533__"